export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILED = 'GET_COUNTRIES_FAILED';

export const GET_STATES = 'GET_STATES';
export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES_FAILED = 'GET_STATES_FAILED';

export const GET_CITIES = 'GET_CITIES';
export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS';
export const GET_CITIES_FAILED = 'GET_CITIES_FAILED';

export const GET_CITIES_BY_STATE_ID = 'GET_CITIES_BY_STATE_ID';
export const GET_CITIES_BY_STATE_ID_SUCCESS = 'GET_CITIES_BY_STATE_ID_SUCCESS';
export const GET_CITIES_BY_STATE_ID_FAILED = 'GET_CITIES_BY_STATE_ID_FAILED';
